import { createRouter, createWebHistory } from 'vue-router'

import EventLocationsView from './views/EventLocationsView.vue'
import ConfigureLockerView from './views/ConfigureLockerView.vue'
import CheckoutView from './views/CheckoutView.vue'
import OrderConfirmedView from './views/OrderConfirmedView.vue'

const routes = [
  {
    path: '/:eventSlug',
    name: 'EventLocations',
    component: EventLocationsView,
    props: true,
  },
  {
    path: '/:eventSlug/:locationSlug',
    name: 'ConfigureLocker',
    component: ConfigureLockerView,
    props: true,
  },
  {
    path: '/checkout/:orderToken',
    name: 'Checkout',
    component: CheckoutView,
    props: true,
  },
  {
    path: '/order/:orderToken/confirmed',
    name: 'OrderConfirmed',
    component: OrderConfirmedView,
    props: true,
  },
]

const router = createRouter({
  history: createWebHistory(),
  routes,
})

export default router
